import { i18n } from '@/locales';
export const distanceProductCode = [
    {
        value: 0,
        text: i18n.t('views.store_management_detail.applied_affiliated_hub_magnification'),
    },
    {
        value: 1.0,
        text: '1.0',
    },
    {
        value: 1.1,
        text: '1.1',
    },
    {
        value: 1.2,
        text: '1.2',
    },
    {
        value: 1.3,
        text: '1.3',
    },
    {
        value: 1.4,
        text: '1.4',
    },
    {
        value: 1.5,
        text: '1.5',
    },
];
const distanceProduct = {};
distanceProductCode.forEach(({ value, text }) => {
    distanceProduct[value] = {
        value,
        text,
    };
});
// export default distanceProduct;
export const distanceProductCodeObj = distanceProduct;
